import { forkJoin } from 'rxjs';
import { NgForm } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import Swal from 'sweetalert2/src/sweetalert2.js';
import { Eq5dService } from 'src/app/services/eq5d.service';
import { UserTaskStatusService } from 'src/app/services/user-task-status.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-eq5d',
  templateUrl: './eq5d.component.html',
  styleUrls: ['./eq5d.component.scss'],
})
export class Eq5dComponent implements OnInit {
  @ViewChild('form', { static: false }) eq5dForm?: NgForm;
  completed = false;
  responses = {
    mobility: 0,
    selfcare: 0,
    activities: 0,
    pain: 0,
    anxiety: 0,
  };
  submittedResponses: any;
  step = 1;
  value = 50;
  options: Options = {
    floor: 0,
    ceil: 100,
    vertical: true,
    showSelectionBar: true,
    tickStep: 1,
    showTicks: true,
    showTicksValues: false,
    stepsArray: [],
  };

  isLoading = false;
  userData: any;
  taskStatus = false;
  stage = 1;
  gettingStarted = false;
  currentYear: number = new Date().getFullYear();

  constructor(
    private eq5dService: Eq5dService,
    private userTaskStatusService: UserTaskStatusService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    if(this.router.url == '/getting-started/eq5d'){
      this.gettingStarted = true;
    }
    this.route.params.subscribe((params) => {
      if (params.stage) {
        this.stage = params.stage;
      }
    });

    for (let x = 0; x < 101; x++) {
      if (x % 10 === 0) {
        this.options.stepsArray?.push({ value: x, legend: '' + x });
      } else {
        this.options.stepsArray?.push({ value: x });
      }
    }

    this.isLoading = true;
    forkJoin({
      responses: this.eq5dService.fetchResponse(this.stage),
      userStageTaskStatuses: this.userTaskStatusService.fetchAll(),
    }).subscribe(
      (responseData) => {
        this.isLoading = false;
        this.submittedResponses = responseData.responses;

        // have they answered it?
        if (this.submittedResponses) {
          this.completed = true;
        }
      },
      (error) => {
        // console.log(error);
      }
    );
  }

  onPrevious() {
    this.step--;
  }

  onNext() {
    this.step++;
  }

  onSubmit() {
    // console.log(this.eq5dForm.value);

    this.eq5dService
      .saveResponse(
        this.stage,
        this.eq5dForm?.value.mobility,
        this.eq5dForm?.value.selfcare,
        this.eq5dForm?.value.activities,
        this.eq5dForm?.value.pain,
        this.eq5dForm?.value.anxiety,
        this.value
      )
      .subscribe((responseData) => {
        this.completed = true;
        window.scroll(0, 0);
        this.completed = true;
        // complete the task?

        if (this.stage == 1) {
          // complete it

          this.userTaskStatusService.create('eq5dPre', 1).subscribe(
            (taskResponseData) => {
              this.taskStatus = true;
              Swal.fire(
                'Task Complete',
                "You completed the 'Questionnaires' task, well done!",
                'success'
              );
            },
            (error) => {
              // console.log(error);
            }
          );
        }
      });
  }
}
